<div class="modal-header">
    <h4 class="modal-title roboTitle" id="modal-basic-title">{{'configuration.dashboard.searchReseller' | translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" style="padding: 10px">
    <div style="display: flex; flex-direction: row;align-items: baseline;flex-wrap: wrap;">
        <h5 class="roboSubTitle">{{'configuration.dashboard.searchBy' | translate}}:</h5>
        <div *ngIf="innerWidth! <= 767" class="break" style="margin-bottom: 10px;"></div>
        <div class="input-group" style="margin-left: 10px; flex: 1;">
            <input type="text" [ngClass]="( titleSearch.length > 3 ) ? '' : 'borderRed'" [ngStyle]="{'border-radius': '10px 0px 0px 10px'}" [(ngModel)]="titleSearch" (keyup)="search($event)" class="form-control" 
            [placeholder]="'configuration.dashboard.name_vat' | translate" aria-label="Cerca per nome o piva" aria-describedby="basic-addon1">
            <span class="input-group-text" id="basic-addon1" (click)="search(null)"><i class="bi bi-search"></i> <!--{{ 'general.search' | translate }}--> </span>
        </div>
    </div>
    <div style="align-items: baseline;flex-wrap: wrap;" class="text-right mt-2">
        <button [disabled]="previousPage==currentPage" class="btn btn-sm mr-1" (click)="prev()"><img src="assets/icone_varie/arrow_down.svg" style="transform: rotate(90deg);"></button>
        <button [disabled]="currentPage==nextPage" class="btn btn-sm" (click)="next()"><img src="assets/icone_varie/arrow_down.svg" style="transform: rotate(270deg);"></button>
    </div>
    <div style="margin: 0;margin-top: 5px;overflow-x: auto;">
        <table class="table" *ngIf="managedUsersTable && managedUsersTable.data.length > 0">
            <thead>
                <tr>
                    <th scope="col">{{'invoices.edit.entities.other.denomination' | translate}}</th>
                    <th scope="col">{{'invoices.edit.entities.other.piva' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let u of managedUsersTable.data" (click)="selectOne(u.email)" style="cursor: pointer;">
                    <td>
                        <h5>{{u.denominazione}}</h5>
                    </td>
                    <td>
                        <h5>{{u.codice_fiscale}} {{u.partita_iva}}</h5>
                    </td>
                </tr>
            </tbody>    
        </table>
        <ng-container *ngIf="managedUsersTable && managedUsersTable.data.length == 0 && !first && !loading">
            <ngb-toast [autohide]="false" class="warning">
                <img src="assets/icone_varie/info.png" style="width: 20px; margin-right: 5px;">
                {{'general.noResults' | translate}}
            </ngb-toast>
        </ng-container>
        <app-loading *ngIf="loading"></app-loading>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
</div>